import jwt_decode from 'jwt-decode'
import { privateAPI } from '../../config/constants'
import { decrypt } from '../../functions/globalFunctions'

let tokenData
if (localStorage.getItem('token')) {
  let token = jwt_decode(localStorage.getItem('token'))
  tokenData = decrypt(token.data)
}

export const getCommulativePurchaseOnline = () => {
  return async () => {
    const { data } = await privateAPI.post(`/offline/commulative-purchases/${tokenData?.vendorId}`)
    if (data) {
      return decrypt(data)
    }
  }
}
export const getCommulativeDataOnline = (page) => {
  return async () => {
    const { data } = await privateAPI.post(
      `/offline/commulative-users/${tokenData?.vendorId}?page=${page}`,
    )
    if (data) {
      return decrypt(data)
    }
  }
}

export const getMonthlyInvoices = (date) => {
  return async () => {
    const { data } = await privateAPI.post(
      `/general/commulative-users-monthly-invoices/${tokenData?.vendorId}/${date}`,
      {
        data: {
          date,
        },
      },
    )
    if (data) {
      return decrypt(data)
    }
  }
}

export const getProductProfiling = (productName) => {
  return async () => {
    const { data } = await privateAPI.post(`/general/get-product-profiling`, {
      data: {
        productName,
      },
    })
    if (data) {
      return decrypt(data)
    }
  }
}

export const getProductCategories = () => {
  return async () => {
    const { data } = await privateAPI.post(`/general/get-product-categories`)
    if (data) {
      return decrypt(data)
    }
  }
}

export const getProductCodes = (code) => {
  return async () => {
    const { data } = await privateAPI.post(`/general/get-product-codes`, {
      data: { code },
    })
    if (data) {
      return decrypt(data)
    }
  }
}
